import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";

export default class ReferralManagerPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            facebookId: "",
            gemAmount: "",
            paymentType: "VIETCOMBANK_REFUND",
            loading: false
        };
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        
        const { facebookId, gemAmount, paymentType } = this.state;

        // Validation
        if (!facebookId || !facebookId.trim()) {
            toast.warning("Vui lòng nhập Facebook ID");
            return;
        }

        if (!gemAmount || isNaN(gemAmount) || Number(gemAmount) <= 0) {
            toast.warning("Vui lòng nhập số lượng Gem hợp lệ");
            return;
        }

        if (!paymentType) {
            toast.warning("Vui lòng chọn loại thanh toán");
            return;
        }

        // Prepare data
        const data = {
            facebookId: facebookId.trim(),
            gemAmount: Number(gemAmount),
            paymentType: paymentType
        };

        this.setState({ loading: true });

        // Call API
        axios.post(
            `${global.config.apiDomain}/mc-user/referral/web/refund-gem`,
            JSON.stringify(data),
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        )
        .then(res => {
            this.setState({ loading: false });
            if (res.data && res.data.status === "OK") {
                toast.success(res.data.message || "Hoàn trả Gem thành công");
                // Reset form
                this.setState({
                    facebookId: "",
                    gemAmount: "",
                    paymentType: "VIETCOMBANK_REFUND"
                });
            } else {
                toast.warning(res.data.message || "Có lỗi xảy ra");
            }
        })
        .catch(error => {
            this.setState({ loading: false });
            const errorMessage = error.response?.data?.message || error.message || "Đã xảy ra lỗi khi gửi yêu cầu";
            toast.error(errorMessage);
            console.error("Error:", error);
        });
    }

    render() {
        const { facebookId, gemAmount, paymentType, loading } = this.state;

        return (
            <div className="container-fluid" style={{ marginTop: "100px", marginBottom: "20px" }}>
                <div className="row">
                    <div className="col-md-8 offset-md-2">
                        <div className="card">
                            <div className="card-header bg-primary text-white">
                                <h3 className="card-title mb-0">
                                    <i className="fa-solid fa-user-group mr-2"></i>
                                    Quản lý Referral - Thu hồi Gem khi refund 
                                </h3>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.handleSubmit}>
                                    <div className="form-group">
                                        <label htmlFor="facebookId">
                                            <strong>Facebook ID *</strong>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="facebookId"
                                            name="facebookId"
                                            value={facebookId}
                                            onChange={this.handleInputChange}
                                            placeholder="Nhập Facebook ID"
                                            required
                                            disabled={loading}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="gemAmount">
                                            <strong>Số lượng Gem *</strong>
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="gemAmount"
                                            name="gemAmount"
                                            value={gemAmount}
                                            onChange={this.handleInputChange}
                                            placeholder="Nhập số lượng Gem"
                                            min="1"
                                            required
                                            disabled={loading}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="paymentType">
                                            <strong>Loại thanh toán *</strong>
                                        </label>
                                        <select
                                            className="form-control"
                                            id="paymentType"
                                            name="paymentType"
                                            value={paymentType}
                                            onChange={this.handleInputChange}
                                            required
                                            disabled={loading}
                                        >
                                            <option value="VIETCOMBANK_REFUND">VietcomBank Refund</option>
                                            <option value="APPLEPRODUCT_REFUND">Apple Refund</option>
                                            <option value="GOOGLEPRODUCT_REFUND">Google Refund</option>
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-block"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                    Đang xử lý...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fa-solid fa-paper-plane mr-2"></i>
                                                    Gửi yêu cầu hoàn trả
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

